import React from 'react';
import PropTypes from 'prop-types';


// third-party
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';

// load locales files


// ==============================|| LOCALIZATION ||============================== //

const Locales = ({ children }) => {
    const { language, currentTranslations } = useSelector(state => state.configurator);

    return (
      <>
        <IntlProvider locale={language} defaultLocale="es" messages={currentTranslations}>
          {children}
        </IntlProvider>
      </>
    );
};

Locales.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Locales;
